import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              换妻一族
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              开放关系探索者的深度指南平台，为好奇者提供客观、理性的资讯与知识。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">内容分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/xinli-dongji" className="text-sm text-background-300 hover:text-background-50 transition-colors">心理动机</Link>
              <Link to="/category/anquan-shouze" className="text-sm text-background-300 hover:text-background-50 transition-colors">安全守则</Link>
              <Link to="/category/falv-bianjie" className="text-sm text-background-300 hover:text-background-50 transition-colors">法律边界</Link>
              <Link to="/category/shequn-wenhua" className="text-sm text-background-300 hover:text-background-50 transition-colors">社群文化</Link>
              <Link to="/category/jingyan-fenxiang" className="text-sm text-background-300 hover:text-background-50 transition-colors">经验分享</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">联系方式</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">用户口碑</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">免责声明</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              本站内容仅供成年读者参考学习，不构成任何行为建议。请遵守所在地区的法律法规。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 换妻一族. 保留所有权利.
          </p>
          <p className="text-xs text-background-400">
            本网站内容仅供18岁以上成年人阅读
          </p>
        </div>
      </div>
    </footer>
  );
}